export default __webpack_public_path__ + "static/media/creditCard.77821326.svg";